<template>
  <div v-if="visible" class="announcement-modal-overlay" @click="closeModal">
    <div class="announcement-modal-content" @click.stop>
      <div class="announcement-header">
        <h3>{{ announcement.title || '系统公告' }}</h3>
        <span class="close-btn" @click="closeModal">&times;</span>
      </div>
      <div class="announcement-body">
        <p v-html="announcement.content"></p>
      </div>
      <div class="announcement-footer">
        <button class="confirm-btn" @click="closeModal">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnnouncementModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    announcement: {
      type: Object,
      default: () => ({
        title: '',
        content: ''
      })
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.announcement-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.announcement-modal-content {
  background: white;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.announcement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.announcement-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 5px;
}

.close-btn:hover {
  color: #333;
}

.announcement-body {
  padding: 20px;
  line-height: 1.6;
  color: #666;
}

.announcement-footer {
  padding: 20px;
  text-align: right;
  border-top: 1px solid #eee;
}

.confirm-btn {
  padding: 8px 20px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-btn:hover {
  background-color: #66b1ff;
}
</style>